import { Link } from 'react-router-dom';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import useLoginFields from '@jetshop/core/components/Auth/useLoginFields';
import useSignupForm from '@jetshop/core/components/Auth/useSignupForm';
import { TrendButton } from '@jetshop/ui/Button';
import { css, cx } from 'linaria';
import React, { useState } from 'react';
import Input from '../../Forms/Input';
import { GlobalError } from '../../Forms/GlobalError';
import { SmallCaps } from '../../ui/Headings';
import { StyledCheck } from '@jetshop/ui/Select/Components';
import { theme } from '../../Theme';
import { Field } from 'formik';

const sectionStyle = css`
  .submit-button {
    background: ${theme.colors.blue};
  }

  .consent {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
    padding: 20px;
    border: 1px solid #ddd;
    margin-bottom: 20px;
    &:hover {
      .checkbox-column div {
        background: #ddd;
      }
    }

    a {
      color: #0073bb;
    }

    .links {
      margin-top: 5px;
    }

    p {
      font-size: 13px !important;
      margin-bottom: 0 !important;
    }
  }
`;

const FakeCheckbox = styled('div')`
  width: 25px;
  height: 25px;
  border: 1px solid #000;
  background: white;
  position: relative;
  margin-right: 10px;
  svg {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: auto;
    height: 15px;
  }
  &.active {
    svg {
      display: block;
    }
  }
`;

export default function LoginFields(props) {
  const [active, setActive] = useState(false);
  const { fields } = useLoginFields();
  const { globalError, isSubmitting } = useSignupForm();

  return (
    <section className={cx('section', sectionStyle)}>
      <Field type="checkbox" name="preferences.type.acceptsEmail" />
      <Field type="checkbox" name="preferences.type.acceptsSms" />

      <SmallCaps className="heading">{t('Email & Password')}</SmallCaps>

      {globalError && (
        <GlobalError style={{ marginBottom: '2em' }}>{globalError}</GlobalError>
      )}

      {fields.map(field => {
        return <Input {...field.inputProps} />;
      })}

      <div className="consent" onClick={() => setActive(!active)}>
        <div className="column checkbox-column">
          <FakeCheckbox className={active && 'active'}>
            <StyledCheck />
          </FakeCheckbox>
        </div>
        <div className="column">
          <p>
            Jeg godkjenner{' '}
            <Link to="/kundeservice/personvern">brukervilkårene</Link> og får
            tilgang til fordeler som medlem av Team Torshov.
          </p>
        </div>
      </div>

      <TrendButton
        className="submit-button"
        data-testid="sign-up-button"
        type="submit"
        disabled={isSubmitting || !active}
      >
        {isSubmitting ? t('Hold on a moment…') : t('Create Profile')}
      </TrendButton>
    </section>
  );
}
